"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAUNCH_DARKLY_PROXY_URL = exports.validateFeatureSwitches = exports.transformAndFilterFeatureSwitches = void 0;
var _tryInvokeFunc = function (fn) {
    try {
        var res = fn();
        return res;
    }
    catch (err) {
        return undefined;
    }
};
/**
 *
 *
 * @template T
 * @param {T} featureSwitches
 * @return {*}  {{ [k in keyof T]: boolean }}
 * transform {[key: string]: boolean | ()=>boolean} into {[key: string]: boolean}
 */
var transformAndFilterFeatureSwitches = function (featureSwitches) {
    var res = {};
    Object.keys(featureSwitches).forEach(function (key) {
        var value = featureSwitches[key];
        if (typeof value === "function") {
            var resValue = _tryInvokeFunc(value);
            if (typeof resValue === "boolean") {
                res[key] = resValue;
            }
        }
        if (typeof value === "boolean") {
            res[key] = value;
        }
    });
    return res;
};
exports.transformAndFilterFeatureSwitches = transformAndFilterFeatureSwitches;
/**
 *
 *
 * @template T
 * @param {T} featureSwitches
 * @return {*}  {T}
 * check if initial feature switches match type {[key: string]: boolean}
 */
var validateFeatureSwitches = function (featureSwitches) {
    for (var key in featureSwitches) {
        var value = featureSwitches[key];
        if (typeof value !== "boolean") {
            throw new Error("Invalid feature switches, key: " + key + ", expected value type: boolean, but got: " + typeof value);
        }
    }
    return featureSwitches;
};
exports.validateFeatureSwitches = validateFeatureSwitches;
exports.LAUNCH_DARKLY_PROXY_URL = "https://proxy.crimsoneducation.io/ld";
